import { ReactNode, useRef } from 'react';
import { Container } from '@mui/material';
import { useIosKeyboardScroller } from 'hooks/useIosKeyboardScroller';

type AlertEditingContainerProps = {
  children: ReactNode;
};

export const AlertEditingLayout = (
  props: AlertEditingContainerProps,
): JSX.Element => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  useIosKeyboardScroller(scrollContainerRef);
  const { children } = props;

  return (
    <Container
      maxWidth="md"
      sx={{
        paddingTop: 2,
        paddingBottom: 'max(env(safe-area-inset-bottom), 16px)',
        width: '100%',
        overflowY: 'auto',
      }}
      ref={scrollContainerRef}
    >
      {children}
    </Container>
  );
};
